import React from 'react';
import toast from 'react-hot-toast';

/**
 * window.prompt 대체 - Electron에서 alert/prompt 후 input 먹통 방지.
 * Promise 기반으로 동작하며 toast UI 위에 input을 띄웁니다.
 *
 * 사용법: const text = await promptDialog('새 이름을 입력하세요', currentName);
 *   - 사용자가 취소하거나 빈 값이면 null 반환
 *   - 확인하면 trim된 문자열 반환
 */
export function promptDialog(message, defaultValue = '') {
  return new Promise((resolve) => {
    const tid = toast(
      (t) => {
        const inputRef = React.createRef();
        const submit = () => {
          const v = inputRef.current?.value?.trim() || '';
          toast.dismiss(t.id);
          resolve(v ? v : null);
        };
        const cancel = () => {
          toast.dismiss(t.id);
          resolve(null);
        };
        return React.createElement(
          'div',
          { style: { display: 'flex', flexDirection: 'column', gap: '10px', minWidth: '280px' } },
          React.createElement(
            'span',
            { style: { fontSize: '14px', lineHeight: '1.5', color: '#f9fafb', fontWeight: 500 } },
            message
          ),
          React.createElement('input', {
            ref: inputRef,
            type: 'text',
            defaultValue,
            autoFocus: true,
            onKeyDown: (e) => {
              if (e.key === 'Enter') { e.preventDefault(); submit(); }
              else if (e.key === 'Escape') { e.preventDefault(); cancel(); }
            },
            style: {
              padding: '8px 10px', borderRadius: '6px', border: '1px solid #4b5563',
              background: '#ffffff', color: '#111827', fontSize: '13.5px', outline: 'none',
            },
          }),
          React.createElement(
            'div',
            { style: { display: 'flex', justifyContent: 'flex-end', gap: '8px' } },
            React.createElement(
              'button',
              {
                onClick: cancel,
                style: {
                  padding: '6px 16px', borderRadius: '6px', border: '1px solid #4b5563',
                  background: '#ffffff', color: '#111827', cursor: 'pointer', fontSize: '13px', fontWeight: 500,
                },
              },
              '취소'
            ),
            React.createElement(
              'button',
              {
                onClick: submit,
                style: {
                  padding: '6px 16px', borderRadius: '6px', border: 'none',
                  background: '#2563eb', color: '#ffffff', cursor: 'pointer', fontSize: '13px', fontWeight: 500,
                },
              },
              '확인'
            )
          )
        );
      },
      { duration: Infinity, position: 'top-center' }
    );
    return tid;
  });
}
